export const isAdministratorGroup = (userGroups) =>
  Array.isArray(userGroups) &&
  userGroups.some(
    (group) =>
      String(group?.name || group?.group || group?.group_name || "")
        .toLowerCase() === "administrator"
  );

const groupValuesForItem = (item) => [
  item?.group,
  item?.group?.id,
  item?.group?.name,
  item?.groups,
  item?.group_id,
  item?.groupId,
  item?.id_group,
  item?.idGroup,
  item?.meeting_group,
  item?.meeting_group?.id,
  item?.meeting_group?.name,
  item?.meetingGroup,
  item?.meetingGroup?.id,
  item?.meetingGroup?.name,
];

export const isVisibleToUserGroups = (item, userGroups) => {
  if (isAdministratorGroup(userGroups)) return true;

  const userGroupIds = userGroups.map((group) => String(group?.id));
  const userGroupNames = userGroups.map((group) =>
    String(group?.name || group?.group || group?.group_name || "").toLowerCase()
  );

  return groupValuesForItem(item).some((value) => {
    if (Array.isArray(value)) {
      return value.some((nestedValue) =>
        userGroupIds.includes(String(nestedValue)) ||
        userGroupNames.includes(String(nestedValue).toLowerCase())
      );
    }

    return (
      value !== undefined &&
      value !== null &&
      (userGroupIds.includes(String(value)) ||
        userGroupNames.includes(String(value).toLowerCase()))
    );
  });
};

